import { createSlice } from "@reduxjs/toolkit";
import { postCreateleadMiddleware, patchLeadEditMiddleWare,
  getleadcompanydataMiddleware, getleadtableMiddleware, getPaymentSearchDataMiddleWare, getLeadDataMiddleware, getLeadEditDataMiddleWare } from "./leadMiddleware";
import SvgMotorTable from "../../../assets/agentIcon/SvgMotorTable";
import SvgHomeTable from "../../../assets/agentIcon/SvgHomeTable";
import SvgTravlesTable from "../../../assets/agentIcon/SvgTravlesTable";

const initialState = {
  loading: false,
  error: "",

  leadtabledata: [
    {
      id: "1",
      CompanyName: "",
      TaxNumber: "123-456-789-000",
      FirstName: "Juan",
      LastName: "Dela Cruz",
      PreferredName: "Juan",
      EmailID: "juan.delacruz@gmail.com",
      ContactNumber: "+63 917 123 4567",
      HouseNo: "123",
      Barangay: "Barangay 123",
      Country: "Philippines",
      Province: "Metro Manila",
      City: "Makati",
      ZIPCode: "1234",
      DateofBirth: "15/06/1985",
      category: "Individual",
      gender: "Male",
      Quotes: "02",
      LeadID: "LEAD-2025-001",
      Svg: <SvgMotorTable />,
      Type: "Motor",
      LeadSource: "Website Inquiry",
      LeadStatus: "Hot Lead",
      EstimatedPremium: "₱35,000",
      LastContactDate: "28 MAR 2025"
    },
    {
      id: "2",
      CompanyName: "BPO Solutions Inc.",
      TaxNumber: "009-876-543-000",
      FirstName: "Maria",
      LastName: "Santos",
      PreferredName: "Maria",
      EmailID: "maria.santos@bposolutions.ph",
      ContactNumber: "+63 2 8845 6789",
      HouseNo: "456",
      Barangay: "Fort Bonifacio",
      Country: "Philippines",
      Province: "Metro Manila",
      City: "Taguig",
      ZIPCode: "1634",
      DateofBirth: "22/03/1980",
      category: "Company",
      gender: "Female",
      Quotes: "01",
      LeadID: "LEAD-2025-002",
      Svg: <SvgHomeTable />,
      Type: "Property",
      LeadSource: "Referral",
      LeadStatus: "Warm Lead",
      EstimatedPremium: "₱250,000",
      LastContactDate: "27 MAR 2025"
    },
    {
      id: "3",
      CompanyName: "",
      TaxNumber: "456-789-123-000",
      FirstName: "Ana",
      LastName: "Garcia",
      PreferredName: "Ana",
      EmailID: "ana.garcia@yahoo.com",
      ContactNumber: "+63 919 876 5432",
      HouseNo: "789",
      Barangay: "Poblacion",
      Country: "Philippines",
      Province: "Cebu",
      City: "Cebu City",
      ZIPCode: "6000",
      DateofBirth: "10/11/1992",
      category: "Individual",
      gender: "Female",
      Quotes: "03",
      LeadID: "LEAD-2025-003",
      Svg: <SvgTravlesTable />,
      Type: "Travel",
      LeadSource: "Social Media",
      LeadStatus: "Hot Lead",
      EstimatedPremium: "₱5,500",
      LastContactDate: "28 MAR 2025"
    },
    {
      id: "4",
      CompanyName: "Logistics Express Corp",
      TaxNumber: "111-222-333-000",
      FirstName: "Roberto",
      LastName: "Reyes",
      PreferredName: "Robert",
      EmailID: "roberto.reyes@logisticsexpress.ph",
      ContactNumber: "+63 2 8123 4567",
      HouseNo: "321",
      Barangay: "Alabang",
      Country: "Philippines",
      Province: "Metro Manila",
      City: "Muntinlupa",
      ZIPCode: "1780",
      DateofBirth: "05/07/1978",
      category: "Company",
      gender: "Male",
      Quotes: "04",
      LeadID: "LEAD-2025-004",
      Svg: <SvgMotorTable />,
      Type: "Motor",
      LeadSource: "Cold Call",
      LeadStatus: "Qualified Lead",
      EstimatedPremium: "₱450,000",
      LastContactDate: "26 MAR 2025"
    },
    {
      id: "5",
      CompanyName: "",
      TaxNumber: "987-654-321-000",
      FirstName: "Carmen",
      LastName: "Bautista",
      PreferredName: "Carmen",
      EmailID: "carmen.bautista@gmail.com",
      ContactNumber: "+63 918 765 4321",
      HouseNo: "555",
      Barangay: "San Antonio",
      Country: "Philippines",
      Province: "Laguna",
      City: "San Pedro",
      ZIPCode: "4023",
      DateofBirth: "18/09/1988",
      category: "Individual",
      gender: "Female",
      Quotes: "01",
      LeadID: "LEAD-2025-005",
      Svg: <SvgTravlesTable />,
      Type: "Travel",
      LeadSource: "Partner Referral",
      LeadStatus: "New Lead",
      EstimatedPremium: "₱8,200",
      LastContactDate: "25 MAR 2025"
    },
    {
      id: "6",
      CompanyName: "Restaurant Chain Philippines",
      TaxNumber: "555-444-333-000",
      FirstName: "Pedro",
      LastName: "Gonzales",
      PreferredName: "Pete",
      EmailID: "pedro.gonzales@restaurantchain.ph",
      ContactNumber: "+63 2 8999 8888",
      HouseNo: "999",
      Barangay: "Greenhills",
      Country: "Philippines",
      Province: "Metro Manila",
      City: "San Juan",
      ZIPCode: "1500",
      DateofBirth: "30/12/1975",
      category: "Company",
      gender: "Male",
      Quotes: "05",
      LeadID: "LEAD-2025-006",
      Svg: <SvgHomeTable />,
      Type: "Property",
      LeadSource: "Exhibition",
      LeadStatus: "Negotiation",
      EstimatedPremium: "₱380,000",
      LastContactDate: "24 MAR 2025"
    },
    {
      id: "7",
      CompanyName: "",
      TaxNumber: "777-888-999-000",
      FirstName: "Miguel",
      LastName: "Torres",
      PreferredName: "Mike",
      EmailID: "miguel.torres@outlook.com",
      ContactNumber: "+63 920 123 4567",
      HouseNo: "777",
      Barangay: "Marikina Heights",
      Country: "Philippines",
      Province: "Metro Manila",
      City: "Marikina",
      ZIPCode: "1810",
      DateofBirth: "14/02/1990",
      category: "Individual",
      gender: "Male",
      Quotes: "02",
      LeadID: "LEAD-2025-007",
      Svg: <SvgMotorTable />,
      Type: "Motor",
      LeadSource: "Online Quote",
      LeadStatus: "Follow-up Required",
      EstimatedPremium: "₱42,000",
      LastContactDate: "23 MAR 2025"
    },
    {
      id: "8",
      CompanyName: "Tech Startup Manila",
      TaxNumber: "222-333-444-000",
      FirstName: "Elena",
      LastName: "Martinez",
      PreferredName: "Elena",
      EmailID: "elena@techstartup.ph",
      ContactNumber: "+63 917 999 8888",
      HouseNo: "888",
      Barangay: "Salcedo Village",
      Country: "Philippines",
      Province: "Metro Manila",
      City: "Makati",
      ZIPCode: "1227",
      DateofBirth: "25/05/1987",
      category: "Company",
      gender: "Female",
      Quotes: "01",
      LeadID: "LEAD-2025-008",
      Svg: <SvgHomeTable />,
      Type: "Property",
      LeadSource: "LinkedIn",
      LeadStatus: "Proposal Sent",
      EstimatedPremium: "₱95,000",
      LastContactDate: "22 MAR 2025"
    },
  ],
  createleaddata: {},
  LeadEditdata: {},
  getEditLeadData: {},
  leadcompanydata: {}
};

const leadReducer = createSlice({
  name: "leadReducer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(getLeadDataMiddleware.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getLeadDataMiddleware.fulfilled,
      (state, action) => {
        state.loading = false;
        state.leadtabledata = action.payload

      }
    );

    builder.addCase(
      getLeadDataMiddleware.rejected,
      (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === "string" ? action.payload : "";
      }
    );


    //getcompany
    builder.addCase(getleadcompanydataMiddleware.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getleadcompanydataMiddleware.fulfilled,
      (state, action) => {
        state.loading = false;
        state.leadcompanydata = action.payload

      }
    );

    builder.addCase(
      getleadcompanydataMiddleware.rejected,
      (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === "string" ? action.payload : "";
      }
    );

    //postCreateleadMiddleware

    builder.addCase(postCreateleadMiddleware.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postCreateleadMiddleware.fulfilled, (state, action) => {
      console.log(action.payload, 'find action.payload')
      state.loading = false;
      state.leadtabledata = [...state.leadtabledata, action.payload];
    });
    builder.addCase(
      postCreateleadMiddleware.rejected,
      (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === "string" ? action.payload : "";
      }
    );
    //getleadtableMiddleware

    builder.addCase(getleadtableMiddleware.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getleadtableMiddleware.fulfilled,
      (state, action) => {
        state.loading = false;
        state.leadtabledata = action.payload
      }
    );
    builder.addCase(
      getleadtableMiddleware.rejected,
      (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === "string" ? action.payload : "";
      }
    );

    //patchLeadEditMiddleWare

    builder.addCase(patchLeadEditMiddleWare.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      patchLeadEditMiddleWare.fulfilled,
      (state, action) => {
        state.loading = false;
        const updatedIndex = state.leadtabledata.findIndex(
          (item) => item.id === action.payload.id
        );
        if (updatedIndex !== -1) {
          const updatedCurrencyList = [...state.leadtabledata];
          updatedCurrencyList[updatedIndex] = action.payload;
          state.leadtabledata = updatedCurrencyList;
        } else {
          state.leadtabledata = [...state.leadtabledata, action.payload];
        }
      }
    );
    builder.addCase(
      patchLeadEditMiddleWare.rejected,
      (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === "string" ? action.payload : "";
      }
    );

    builder.addCase(getPaymentSearchDataMiddleWare.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPaymentSearchDataMiddleWare.fulfilled, (state, action) => {
      state.loading = false;
      state.paymentSearchList = action.payload;
    });
    builder.addCase(getPaymentSearchDataMiddleWare.rejected, (state, action) => {
      state.loading = false;

      state.paymentSearchList = {};
      state.error = typeof action.payload === "string" ? action.payload : "";
    });

    builder.addCase(getLeadEditDataMiddleWare.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLeadEditDataMiddleWare.fulfilled, (state, action) => {
      console.log(action.payload, 'find action.payload');
      state.loading = false;
      state.getEditLeadData = action.payload;
    });
    builder.addCase(
      getLeadEditDataMiddleWare.rejected,
      (state, action) => {
        state.loading = false;
        state.error = typeof action.payload === "string" ? action.payload : "";
      }
    );
  },
});

export default leadReducer.reducer;
